// Converts 7523 -> $75.23
export default (cents) => {
  if (Math.floor(cents / 100) === cents / 100) {
    return `$${Math.floor(cents / 100)}`;
  } else {
    return `$${String(Math.floor(cents / 100))}`;
  }
};
